/* ============================================================================
 * PRODUCT FORM SUBMISSION (js__product-submit.js)
 * ============================================================================ */

window.onSubmitCartForm = async (form, event) => {
  event.preventDefault();
  
  // 1. Cache form elements
  const btnTxt = form.querySelector('.btn-cart span:first-child');
  const input = form.querySelector('input[name="quantity"]');
  const quantity = form.querySelector('.cart-quantity');
  const btnMinus = form.querySelector('.btn-minus');
  const btnPlus = form.querySelector('.btn-plus');
  const submitButton = btnTxt ? btnTxt.closest('button') : null;

  // 2. Set loading state
  btnTxt.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
  if (submitButton) submitButton.disabled = true;
  disableBtns(form); // Disable +/- buttons

  // 3. Prepare fetch variables
  const fetchBody = new FormData(form);
  const fetchHeaders = {};

  // 4. Perform the single fetch call
  const response = await fetch('/cart/add.js', { 
    method: 'POST', 
    body: fetchBody,
    headers: fetchHeaders
  });

  // 5. Handle success and reset form
  btnTxt.innerHTML = `${window.theme.product.addToCart}`;
  window.refreshCartContents(response);
  bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();

  if (submitButton) submitButton.disabled = false;
  enableBtns(form); // Re-enable +/- buttons

  // Reset quantity inputs
  if (input && quantity && btnMinus && btnPlus) {
    input.value = 1;
    quantity.textContent = 1;
    btnMinus.disabled = true;
    const max = parseInt(btnPlus.dataset.max || 1);
    btnPlus.disabled = (max <= 1);
  }
}